<template>
  <div>
    <div
      :class="{ 'mb-0': noMargin }"
      class="form-group"
    >
      <label
        v-if="title"
        :for="id"
      >
        {{ title }} <span class="text-muted" v-if="optional">(optional)</span>
        <icon
          style="top: 2px"
          icon="help"
          v-if="tooltip"
          v-tooltip="tooltip"
        />
      </label>
      <input
        v-if="type !== 'textarea'"
        :id="id"
        v-model="myValue"
        :class="{ 'is-invalid': errors && errors.length > 0 }"
        :disabled="disabled"
        :readonly="readonly"
        :type="type"
        :placeholder="placeholder"
        :maxlength="maxlength"
        class="form-control"
      >
      <textarea
        v-else
        :id="id"
        v-model="myValue"
        :class="{ 'is-invalid': errors && errors.length > 0 }"
        :placeholder="placeholder"
        :type="type"
        :disabled="disabled"
        class="form-control"
      />
      <form-control-error
        :errors="errors"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
    maxlength: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    errors: {
      type: Array,
      default () {
        return []
      },
    },
    optional: {
      type: Boolean,
    },
    value: {
      validator (value) {
        return ['number', 'string'].indexOf(typeof value) !== -1
      },
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
    showRemove: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      myValue: null,
      fileList: [],
    }
  },

  computed: {
    id () {
      return this.title ? this.title.replace(/[^A-Za-z0-9]+/g, '-').toLowerCase() : Math.random()
    },
  },

  watch: {
    myValue () {
      this.$emit('input', this.myValue)
    },

    value () {
      this.myValue = this.value
    },
  },

  mounted () {
    if (this.type === 'file' && this.value) {
      this.fileList.push({
        name: 'your uploaded file',
      })
    }
    this.myValue = this.value
  },

  methods: {
    fileChanged (file, fileList) {
      const reader = new FileReader()

      reader.onload = (e) => {
        // this.value = e.target.result
        this.myValue = e.target.result
      }

      reader.readAsDataURL(file.raw)
    },

    fileRemoved () {
      this.myValue = null
    },
  },
}
</script>

<style lang="scss">
.form-control {
  font-size: 14px !important;
  letter-spacing: $letter-spacing;

  &::placeholder {
    color: $gray-600;
  }

  &:disabled {
    color: #98a0bc;
    background-color: #FBFBFB;
  }

  // important 'cause bootstrap
  &[readonly] {
    background-color: #fbfbfb !important;
    color: #b2b2b2;
  }
}

</style>
